<template>
  <FormPage
    :title="isWizardReturn ? 'Редактирование машины' : `Машина ${car?.number || ''}`"
    :description="isWizardReturn ? 'Измените данные машины-исполнителя.' : ''"
  >
    <template #controls>
      <ExecutorWizardBackButton v-if="isWizardReturn" />
      <BackButton v-if="!isWizardReturn" />
    </template>

    <my-loader v-if="isLoading" />

    <div v-else-if="hasError && !car" class="state-block">
      <h2>Не удалось загрузить машину</h2>
    </div>

    <div v-else-if="car" class="cards">
      <div v-if="isFetching" class="refresh-bar" />

      <CarForm
        mode="edit"
        :initial-data="car"
        :company="wizardCompany"
        :errors="formErrors"
        @update="onUpdate"
        @closeForm="closeForm"
      />

      <div v-if="!isWizardReturn" class="guard-row">
        <guard-button
          :model="'cars'"
          :id="car.id"
          @reloadExecutor="onSecurityReload"
        />
      </div>

      <FormCard v-if="securityInfo && !isWizardReturn" title="Безопасность">
        <CarSecurityInfo
          class="securiti-info"
          :car="{ vin: car.vin, number: car.number }"
          :security="securityInfo"
        />
      </FormCard>
    </div>

    <div v-else class="state-block">
      <h2>Нет Данных</h2>
    </div>
  </FormPage>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import FormPage from '@/components/formKit/FormPage.vue'
import FormCard from '@/components/formKit/FormCard.vue'
import CarForm from '@/components/forms/CarForm.vue'
import CarSecurityInfo from '@/pages/securityCheck/components/CarSecurityInfo.vue'
import ExecutorWizardBackButton from '@/components/UI/ExecutorWizardBackButton.vue'
import { carSecurityInfo } from './carsState.mjs'
import { useCarPage } from './useCarsPage'
import { isExecutorWizardReturn, refreshWizardItem, returnToExecutorWizard } from './executorWizardReturn'
import { useExecutorWizardStore } from '@/stores/executorWizard'

export default {
  name: 'CarDetail',
  components: {
    FormPage,
    FormCard,
    CarForm,
    CarSecurityInfo,
    ExecutorWizardBackButton,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const wizard = useExecutorWizardStore()
    const isWizardReturn = isExecutorWizardReturn(route)
    const carId = computed(() => route.params.id)
    const { car, isLoading, isFetching, hasError, invalidateCar, refetch } = useCarPage(carId)

    const securityInfo = computed(() => carSecurityInfo(car.value))

    const formErrors = computed(
      () => store.state.apiStorage.cars.formErrors || {},
    )
    const wizardCompany = computed(() => wizard.selectItems.companies)

    const onUpdate = async (form) => {
      const ok = await store.dispatch('apiStorage/updateItem', { model: 'cars', form })
      if (!ok) return
      await invalidateCar()
      await refetch()
      if (isExecutorWizardReturn(route)) {
        refreshWizardItem(wizard, route, car.value)
        await returnToExecutorWizard(router)
      }
    }

    const closeForm = () => {
      if (isExecutorWizardReturn(route)) returnToExecutorWizard(router)
    }

    const onSecurityReload = async () => {
      await invalidateCar()
    }

    return {
      car,
      isLoading,
      isFetching,
      hasError,
      securityInfo,
      formErrors,
      wizardCompany,
      isWizardReturn,
      onUpdate,
      closeForm,
      onSecurityReload,
    }
  },
}
</script>

<style scoped>
.state-block {
  padding: 32px;
  color: #667085;
  text-align: center;
}

.cards {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.refresh-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #4f46e5, transparent);
  animation: refresh-slide 1s linear infinite;
}

@keyframes refresh-slide {
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
}

.guard-row {
  margin-top: 5px;
}
</style>
